<script setup>
import NewsGroup from '~/components/news-page/news-group/news-group.vue';

const props = defineProps({
  selectedTag: {
    type: String,
    default: () => '',
  },
  data: {
    type: Array,
    default: () => [],
  },
  chroniclesData: {
    type: Array,
    default: () => [],
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
  isShowMoreButton: {
    type: Boolean,
    default: false,
  },
  isEmptyResults: {
    type: Boolean,
    default: false,
  },
  highlighted: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['fetch']);
function fetchMoreData() {
  emit('fetch');
}
</script>

<template>
  <div class="news-list">
    <div class="news-list__group">
      <NewsGroup
        :data="props.data"
        :chronicles-data="props.chroniclesData"
        :highlight="props.highlighted"
      />

      <div v-show="props.isShowMoreButton" class="news-list__more-button">
        <MoreContentButton @loading="props.isLoading" @click="fetchMoreData" />
      </div>
    </div>

    <div
      v-if="props.isEmptyResults && props.highlighted"
      class="news-list__empty"
    >
      <h2>По этому запросу ничего не найдено</h2>
    </div>
  </div>
</template>

<style scoped lang="postcss">
.news-list {
  min-height: 100vh;

  @media (min-width: 1024px) {
    margin: 0;
  }

  &__empty {
    display: flex;
    min-height: 100vh;
  }

  &__more-button {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin: 24px 0;
  }
}
</style>
